'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _ApiClient = require('./helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _useStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _localStorage = require('./localStorage');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _app = require('firebase/app');

var firebase = _interopRequireWildcard(_app);

var _reactFacebookPixel = require('react-facebook-pixel');

var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
if (_config2.default.gaEnabled) {
  _reactGa2.default.initialize(_config2.default.gaTrackingCode, {
    debug: _config2.default.gaDebugMode,
    testMode: _config2.default.gaTestMode
  });
} else {
  // Fake init to suppress warnings (server-side)
  _reactGa2.default.initialize('', {
    debug: false,
    testMode: false
  });
}

// Initialize Firebase


// Initialize Google Analytics

var firebaseConfig = require(process.env.FIREBASE_CONFIG_PATH || 'firebase-config.json');
firebase.initializeApp(firebaseConfig);

// Initialize Facebook Pixel

if (_config2.default.fbPixelEnabled) {
  var options = {
    autoConfig: true, // set pixel's autoConfig
    debug: false // enable logs
  };
  _reactFacebookPixel2.default.init(_config2.default.fbPixelCode, {}, options);
  _reactFacebookPixel2.default.pageView();
}

var persistState = (0, _localStorage.loadStore)();
var client = new _ApiClient2.default();
var _browserHistory = (0, _useStandardScroll2.default)(function () {
  return _reactRouter.browserHistory;
})();
var dest = document.getElementById('content');

var store = (0, _create2.default)(_browserHistory, client, _lodash2.default.merge(window.__data, persistState));
store.subscribe(_lodash2.default.throttle(function () {
  (0, _localStorage.saveStore)({
    address: store.getState().address,
    auth: store.getState().auth
  });
}, 1000));

var history = (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory, store);
history.listen(function (location) {
  _reactGa2.default.set({ page: location.pathname });
  _reactGa2.default.pageview(location.pathname);
});

var component = _react2.default.createElement(
  _reactRouter.Router,
  {
    onUpdate: function onUpdate() {
      return document.body.scrollTo(0, 0);
    },
    render: function render(props) {
      return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, {
        helpers: { client: client },
        filter: function filter(item) {
          return !item.deferred;
        }
      }));
    },
    history: history
  },
  (0, _routes2.default)(store)
);

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2.default; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
  var DevTools = require('./containers/DevTools/DevTools');
  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      'div',
      null,
      component,
      _react2.default.createElement(DevTools, null)
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1499
// module chunks = 0